module.exports = __webpack_public_path__ + "pigeon.png?37e3e319228c9bc089c159820c291a54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pigeon.png
// module id = 131
// module chunks = 0